import { render, staticRenderFns } from "./CancelMovementBlockModal.vue?vue&type=template&id=494c85cb&"
import script from "./CancelMovementBlockModal.vue?vue&type=script&lang=js&"
export * from "./CancelMovementBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports